import React from "react";
import { Route, Routes, Outlet } from "react-router-dom";
import AdminLayout, { useRoutes } from "../AdminLayout";
import { AppRouteType } from "../helper";
import LoginForm from "../../pages/User/login";

const makeRoutes = (routes: AppRouteType[]): JSX.Element[] => {
  return routes.map((route, idx) => {
    const { component: Component } = route;
    return <Route key={idx} path={route.path} element={<Component />} />;
  });
};

const AppContainer: React.FC = () => {
  const routeAdmin = useRoutes();

  return (
    <Routes>
      <Route path="/" element={<Outlet />}>
        <Route element={<AdminLayout />}>{makeRoutes(routeAdmin)}</Route>
      </Route>
      <Route path="/auth/login" element={<LoginForm />}></Route>
    </Routes>
  )
}

export default AppContainer